import React from "react";
import { MapPin, Briefcase, Plane, ArrowRight, Heart } from "lucide-react";
import { motion } from "framer-motion";

const FeaturedJobCard = ({ job, onNavigate, isSaved, onSaveToggle }) => {
  const handleNavigation = () => onNavigate(`/job-details/${job.id}`);

  const handleSaveToggle = (e) => {
    e.stopPropagation();
    onSaveToggle?.(job.id);
  };

  const aircraftTypes = Array.isArray(job.aircraft_type)
    ? job.aircraft_type
    : [];

  return (
    <motion.div
      onClick={handleNavigation}
      initial={{ opacity: 0, y: 20 }}
      whileInView={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.4 }}
      whileHover={{ y: -6 }}
      className="group bg-white rounded-2xl p-6 shadow-md border border-gray-100
            hover:shadow-xl hover:border-primary-300 cursor-pointer transition-all duration-300 relative"
    >
      {/* Save button */}
      {onSaveToggle && (
        <button
          onClick={handleSaveToggle}
          className={`absolute top-4 right-4 p-2 rounded-full transition
                    ${
                      isSaved
                        ? "text-red-500 bg-red-100"
                        : "text-gray-400 hover:bg-gray-100 opacity-0 group-hover:opacity-100"
                    }`}
        >
          <Heart className={`w-5 h-5 ${isSaved ? "fill-current" : ""}`} />
        </button>
      )}

      <div className="flex items-start gap-4">
        {/* Icon */}
        <div
          className="w-14 h-14 rounded-xl bg-primary-50 
                    flex items-center justify-center text-primary-600"
        >
          <Plane size={24} />
        </div>

        <div className="flex-1 min-w-0">
          {/*Title */}
          <h3
            className="text-lg font-bold text-secondary-900 
                        group-hover:text-primary-700 transition line-clamp-1"
          >
            {job.title}
          </h3>

          {/* Aviation Category */}
          {job.aviation_category && (
            <div className="mt-2">
              <span
                className="inline-block text-xs font-medium 
                 bg-primary-100 text-primary-700 
                 px-3 py-1 rounded-full capitalize"
              >
                {job.aviation_category.replace("-", " ")}
              </span>
            </div>
          )}

          {/* Aircraft Types */}
          {aircraftTypes.length > 0 && (
            <div className="flex flex-wrap gap-2 mt-3">
              {aircraftTypes.slice(0, 3).map((type, index) => (
                <span
                  key={index}
                  className="text-xs bg-gray-100 text-gray-700 
                                    px-3 py-1 rounded-full truncate max-w-[120px]"
                >
                  {type}
                </span>
              ))}
              {aircraftTypes.length > 3 && (
                <span className="text-xs text-gray-500">
                  +{aircraftTypes.length - 3} more
                </span>
              )}
            </div>
          )}

          {/* Meta Info */}
          <div
            className="flex flex-wrap items-center gap-x-6 gap-y-2 
                        text-sm text-gray-600 mt-4"
          >
            <span className="flex items-center truncate max-w-[200px]">
              <MapPin size={14} className="mr-1.5 flex-shrink-0" />
              <span className="truncate">{job.location}</span>
            </span>

            <span className="flex items-center capitalize">
              <Briefcase size={14} className="mr-1.5" />
              {job.job_type?.replace("-", " ")}
            </span>
          </div>
        </div>
      </div>

      {/* Hover CTA */}
      <motion.div
        whileHover={{ x: 4 }}
        className="mt-6 text-primary-600 font-semibold text-sm 
                flex items-center opacity-0 group-hover:opacity-100 transition"
      >
        View Details <ArrowRight size={14} className="ml-1" />
      </motion.div>
    </motion.div>
  );
};

export default FeaturedJobCard;
